import CardDesignCatalogsShowPage from '../../components/pages/card_design_catalogs/CardDesignCatalogsShowPage.vue'
export default {
  components: { CardDesignCatalogsShowPage }
}
